async function foodsDetailsAPI(id) {
  const resolve = await fetch(`https://www.themealdb.com/api/json/v1/1/lookup.php?i=${id}`);
  const data = await resolve.json();
  const meal = data.meals[0];
  return meal;
}

export default foodsDetailsAPI;
